// Define actions
export const actionTypes = {
    CONNECTING: 'CONNECTING',
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
    GENERICERROR: 'GENERICERROR',
    CUSTOMERROR: 'CUSTOMERROR',
    RECEIVED_MESSAGE: 'RECEIVED_MESSAGE',
    CHAT_HISTORY: 'CHAT_HISTORY',
    LOAD_PREV_CHAT: 'LOAD_PREV_CHAT',
    CONNECTED_USERS: 'CONNECTED_USERS',
    SEND_MESSAGE: 'SEND_MESSAGE',
    READ_MESSAGE: 'READ_MESSAGE',
    UNREAD_MESSAGE: 'UNREAD_MESSAGE'
};

// Define actions
export const messagesTypes = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    CUSTOMERROR: 'CUSTOMERROR',
    GENERICERROR: 'GENERICERROR'
};

// Define actions
export const favMenuActionTypes = {
    SET_FAV_MENU: 'SET_FAV_MENU',
    ADD_TO_FAV_MENU: 'ADD_TO_FAV_MENU',
    REMOVE_FROM_FAV_MENU: 'REMOVE_FROM_FAV_MENU',
};